import React, { useContext, useEffect, useState } from "react"
import queryString from "query-string"

import JobList from "../components/job/job-list"
import Layout from "../components/layout/layout"
import { Col, Container, Row } from "react-bootstrap"
import BreadcrumbComponent from "../components/breadcrumb/breadcrum"
import { GlobalAuthContext } from "../context/authContext"
import SEO from "../components/seo"
import SearchButton from "../components/search/search-button"
import { FETCH_COMPANY_DETAILS_DATA } from "../components/shared-actions/fetch-company-details"
import { CANDIDATE_PERSONAL_DATA_FETCH } from "../components/candidate-profile/actions/personalAction"

const CompanyJobPosted = ({ location }) => {
  const { state, dispatch } = useContext(GlobalAuthContext)
  const [activeTabs, setActiveTabs] = useState(0)

  const currentPage = {
    name: "Jobs",
  }
  const home = [
    {
      name: "Home",
      link: "/",
    },
  ]

  const title = "Jobs"

  const hanldeTabsClick = (val) =>{
    setActiveTabs(val)
  }
  useEffect(() => {
    if (!!!state?.profile?.country && state?.user?.company?.id) {
      FETCH_COMPANY_DETAILS_DATA(dispatch, "COMPANY_PROFILE_UPDATE")
    } else if (
      state?.user?.candidate?.id &&
      !!!state?.profile?.avatar?.startsWith("https")
    ) {
      CANDIDATE_PERSONAL_DATA_FETCH(
        state?.user?.id,
        null,
        () => {},
        () => {},
        dispatch
      )
    }
  }, [state?.hasProfile]) // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Layout title="Jobs | WDN" menu={[]} active="Job Posted" noVerification>
      {/* eslint-disable-next-line */}
      <SEO title="Jobs | WDN" />
      <BreadcrumbComponent
        style={"mb-0"} // eslint-disable-line
        pages={home}
        currentPage={
          !!state?.hasProfile ? { name: title, link: "" } : currentPage
        }
      />
      {!!state?.hasProfile && state?.user?.company?.id && (
        <>
          <SearchButton />
        </>
      )}
      <Container>
        <Row className="justify-content-center">
          <Col lg="9">
            <div className="mb-4">
              {state?.job_posted_list?.results?.length > 0 ? (
                <h3 className="my-4">Jobs</h3>
              ) : (
                ""
              )}
               {state?.hasProfile && state?.user?.candidate?.id ? <div className="d-flex tabs align-items-center my-3">
                  <a onClick={()=>hanldeTabsClick(0)} className={`tabs-each mr-1 ${activeTabs===0?"active":""}`}>
                    General
                  </a>
                  <a onClick={()=>hanldeTabsClick(1)} className={`tabs-each ${activeTabs===1?"active":""}`}>
                    Matched
                  </a>
              </div>:""}
              <JobList isGeneral={activeTabs === 0} query_params={queryString.parse(location?.search)} />
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default CompanyJobPosted
